import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";
import { chipContainerStyles, tagStyles } from "SharedComponent/styles/sharedStyles";

export const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "0px 12px 0px 12px",
      height: "100%",
    },
    container: {
      flexDirection: "column",
      height: "100%",
      "& .userItem": {
        width: "100%",
        "&.heading": {
          paddingBottom: theme.spacing(2.5),
          "& p": {
            fontSize: 24,
            color: COLORS.BLACK,
            fontWeight: 600,
          },
        },
        "&.content": {
          backgroundColor: COLORS.WHITE,
          borderRadius: theme.spacing(1),
          height: "calc(100vh - 44px)",
          paddingTop: theme.spacing(1.5),
          "& .hubIdLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
          "& .serviceType": {
            color: "#2D2D2D",
            fontWeight: 500,
            fontSize: 12,
            textTransform: "capitalize",
          },
          '& .panelItem': {
            width: "100%",
            '&.chipFilter': {
              padding: "12px 0px 10px 0px",
              '& .chipsContainer': {
                gap: 8,
                '& .chipFilterItem': {
                  height: 36,
                  minWidth: "11%",
                  borderRadius: theme.spacing(1),
                  border: `1px solid ${COLORS.TRANSPARENT_BLUE_BORDER}`,
                  backgroundColor: COLORS.TRANSPARENT_BLUE,
                  cursor: "pointer",
                  '&:last-child': {
                    marginRight: 0
                  },
                  '&.active': {
                    background: COLORS.AZURE_BLUE,
                    border: "none",
                    boxShadow: "none",
                    '& .chipItem p': {
                      color: COLORS.WHITE
                    }
                  },
                  ...chipContainerStyles(theme)
                }
              }
            },
        }
        },
      },
      
    },
 
    // Next to Search section data
    searchSectionContainer: {
      width: "auto",
      height: "auto",
      margin: "auto 8px",
    },
    searchSectionlSpanStyle: {
      display: "flex",
      color: COLORS.MINE_SHAFT,
      fontWeight: 400,
      fontSize: 14,
      margin: "auto 0px auto 32px",
    },
    searchSectionBoldSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
      margin: "auto 0px auto 4px",
    },
    statusHeaderContainer: {
      '& .tag': {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
      },
  },
  })
);
